import React, { useEffect, useState, useMemo} from 'react';
import {connect} from 'react-redux';
import {injectIntl} from '@s7ui-kit/s7ui-kit';

import { Section } from '../../main/Section';
import requestUtil from '../../../services/services/requestUtil';
import pushGA from '../../../services/utils/pushGA';
import ShopItemCard from '../../../components/common/ShopItemCard/ShopItemCard';
import HorizontalScroll from '../../common/HorizontalScroll/HorizontalScroll';

import {
    analyticsMainPageShopLoaded,
    analyticsMainPageShopShown,
    analyticsMainPageShopClick,
    analyticsMainPageShopClickShowMore
} from '../../../services/analytics/analyticsMainpage';

import '../new-mainpage/shop-block.scss';

const mapStateToProps = ({ App }) => ({ App });

const contentServicePrefix = `${process.env.REACT_APP_PREFIX_CONTENT_SERVICE}/api/v1`;

const ShopBlock = (props) => {
    const {App: {lang, deviceWidth}} = props;
    const { words, getMessage } = props;

    const [ gotShopItems, setGotShopItems ] = useState(false);
    const [ shopItems, setShopItems ] = useState([]);

    const ecomParamsForGA = useMemo(() => {
        return shopItems.map((item, index) => {
            const {id, title, oldPrice, price} = item;
            return {
                item_id: id,
                item_name: title,
                affiliation: 'marketplace',
                coupon: undefined,
                currency: 'RUB',
                discount: (oldPrice - price),
                index: index + 1,
                item_brand: undefined,
                item_category: undefined,
                item_category2: undefined,
                item_category3: undefined,
                item_category4: undefined,
                item_category5: undefined,
                location_id: 's7_main',
                price: price,
                quantity: undefined
            }
        })
    }, [ shopItems ]);

    useEffect(() => {
        const limit = 3;

        const searchParams = new URLSearchParams('');
        searchParams.append('lang', lang);
        searchParams.append('limit', limit);

        requestUtil(`${contentServicePrefix}/content/product?${searchParams}`)
            .then(response => {
                if (!response || !Array.isArray(response.items) || response.items.length === 0) {
                    setGotShopItems(false);
                    return;
                }

                setShopItems(response.items);
                setGotShopItems(true);
            }).catch((e) => {
            console.log(e);
            setGotShopItems(false);
        });
    }, []);

    useEffect(()=> {
        if(!gotShopItems){
            return;
        }
        analyticsMainPageShopLoaded({
            items: ecomParamsForGA
        });
    }, [gotShopItems]);

    const inView = () => {
        analyticsMainPageShopShown({
            items: ecomParamsForGA
        })
    };

    const onClickCard = (item, index) => {
        const {id, title, oldPrice, price} = item;
        const card = {
            item_id: id,
            item_name: title,
            affiliation: 'marketplace',
            coupon: undefined,
            currency: 'RUB',
            discount: (oldPrice - price),
            index: index + 1,
            item_brand: undefined,
            item_category: undefined,
            item_category2: undefined,
            item_category3: undefined,
            item_category4: undefined,
            item_category5: undefined,
            location_id: 's7_main',
            price: price,
            quantity: undefined
        };

        analyticsMainPageShopClick({items:[card]});
    };

    const renderItems = () => {
        const { App: { deviceWidth } } = props;

        if (shopItems.length === 0) {
            return null;
        }

        const items = shopItems.map((item, index) => (
            <div key={item.id} className={'shop-block-item'}>
                <ShopItemCard
                    item={item}
                    gaName='ShopMain'
                    itemClass={'shop-block-holder-item'}
                    onClick={()=>onClickCard(item, index)}
                />
            </div>
        ));

        if (deviceWidth > 1024) {
            return items;
        }

        if (deviceWidth > 767) {
            return items.slice(0, 2);
        }

        return <HorizontalScroll>{items}</HorizontalScroll>;
    };

    if (!gotShopItems || shopItems.length === 0) {
        return null;
    }

    return (<Section
        title={getMessage(words, 'com.s7.main.page.shop.title')}
        className={'shop-block'}
        onClick={()=>{
            analyticsMainPageShopClickShowMore();
            pushGA(
                'PORTAL ShopMain',
                'Click_GoToShop',
                `https://shop.s7.ru/siberia`,
                {
                    eventValue: 0,
                    eventUX: 'link',
                    eventInteraction: 0
                }
            );
        }}
        link={getMessage(words, 'com.s7.main.page.shop.allLink')}
        text={getMessage(words, 'com.s7.main.page.section.shop.show.all')}
        inView={inView}
    >
        <div className={'shop-block-holder'}>
            {renderItems()}
        </div>
    </Section>);
};

export default injectIntl(connect(mapStateToProps)(React.memo(ShopBlock)));
